<template>
  <section>
    <h4 class="fs-20 font-medium mb-4">Budget</h4>

    <checkbox v-model="options.min0">
      {{ budgetRange[0] }}
    </checkbox>
    <checkbox v-model="options.min1000">
      {{ budgetRange[1000] }}
    </checkbox>
    <checkbox v-model="options.min2000">
      {{ budgetRange[2000] }}
    </checkbox>
    <checkbox v-model="options.min4000">
      {{ budgetRange[4000] }}
    </checkbox>
  </section>
</template>

<script>
import ClearFiltersMixin from '../../../mixins/ClearFiltersMixin'
import Checkbox from '../../core/Checkbox'
import currencyRanges from '../../../helpers/currencyRanges';
import { mapState } from "vuex";

export default {
  mixins: [ClearFiltersMixin],
  components: { Checkbox },
  data () {
    return {
      options: this.loadOptions()
    }
  },
  computed: {
    ...mapState(['currency']),
    budgetRange(){
      return currencyRanges[this.currency.code].yacht.filterLabel
    }
  },
  watch: {
    options: {
      deep: true,
      handler (options) {
        let newValue = []
        if (options.min0) newValue.push('0')
        if (options.min1000) newValue.push('1000')
        if (options.min2000) newValue.push('2000')
        if (options.min4000) newValue.push('4000')

        this.$store.commit('setFilter', {
          name: 'budgets',
          value: newValue.join(',')
        })
        this.$store.dispatch('loadSuppliers')
      }
    }
  },
  methods: {
    loadOptions () {
      const filters = this.$store.state.filters
      const budgetValues = filters.budgets.split(',')

      const options = {
        min0: budgetValues.includes('0'),
        min1000: budgetValues.includes('1000'),
        min2000: budgetValues.includes('2000'),
        min4000: budgetValues.includes('4000')
      }

      return options
    }
  },
}
</script>